import React, { createContext, useState, useContext } from 'react';
import PropTypes from 'prop-types';

const HelpContext = createContext();

export const useHelp = () => useContext(HelpContext);

export const HelpProvider = ({ children }) => {
  const [helpKey, setHelpKey] = useState(null);
  const [isHelpVisible, setIsHelpVisible] = useState(false);

  const showHelp = (key) => {
    setHelpKey(key);
    setIsHelpVisible(true);
  };

  const hideHelp = () => {
    setIsHelpVisible(false);
    setHelpKey(null);
  };

  const value = {
    helpKey,
    isHelpVisible,
    showHelp,
    hideHelp,
  };

  return (
    <HelpContext.Provider value={value}>
      {children}
    </HelpContext.Provider>
  );
};

HelpProvider.propTypes = {
  children: PropTypes.node.isRequired,
};
